import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { sendCommunityNotification, CommunityNotificationPayload } from "@/api";

export const useSendCommunityNotification = () => {
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    CommunityNotificationPayload
  >((payload) => sendCommunityNotification(payload));
};
